import { PayMonth } from '../../types';

/**
 * Get readable month and year in Swedish. PayMonth format: YYYYMM
 * @example
 * // returns 'februari 2024'
 * getReadablePayMonth('202402');
 */
export const getReadablePayMonth = (payMonth: PayMonth) => {
  try {
    const date = new Date(Number.parseInt(payMonth.slice(0, 4)), Number.parseInt(payMonth.slice(4)) - 1);
    return date.toLocaleDateString('sv-SE', { year: 'numeric', month: 'long' });
  } catch {
    return '';
  }
};

/**
 * Get readable month and year in Swedish with first letter in capital. PayMonth format: YYYYMM
 * @example
 * // returns 'Februari 2024'
 * getReadableMonthAndYearFromPayMonth('202402');
 */
export const getReadableMonthAndYearFromPayMonth = (payMonth: PayMonth) => {
  try {
    const date = new Date(Number.parseInt(payMonth.slice(0, 4)), Number.parseInt(payMonth.slice(4)) - 1);
    const readableString = date.toLocaleDateString('sv-SE', { year: 'numeric', month: 'long' });
    return readableString.charAt(0).toUpperCase() + readableString.slice(1);
  } catch {
    return '';
  }
};

/**
 * Get readable month and in Swedish with first letter in capital. PayMonth format: YYYYMM
 * @example
 * // returns 'Februari'
 * getReadableMonthFromPayMonth('202402');
 */

export const getReadableMonthFromPayMonth = (payMonth: PayMonth) => {
  try {
    const date = new Date(Number.parseInt(payMonth.slice(0, 4)), Number.parseInt(payMonth.slice(4)) - 1);
    const readableString = date.toLocaleDateString('sv-SE', { month: 'long' });
    return readableString.charAt(0).toUpperCase() + readableString.slice(1);
  } catch {
    return '';
  }
};

export const getPayMonthStartDate = (payMonth: PayMonth) => {
  try {
    return new Date(Date.UTC(Number.parseInt(payMonth.slice(0, 4)), Number.parseInt(payMonth.slice(4)) - 1));
  } catch {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth() - 2, 1);
  }
};

export const getPayMonthFromDate = (date: Date) => {
  return date.getFullYear().toString() + String(date.getMonth()+1).padStart(2, '0');
};
